import { Injectable } from '@angular/core';
import { Menu } from '../biz/Menu';
import { HttpService } from './http.service';
import { DummyService } from './dummy.service';
import { IMenuRequest } from './structure-http-interface/IMenu/IMenuRequest';
import { IMenuResponse, IMenuResponseItems } from './structure-http-interface/IMenu/IMenuResponse';
import { User } from '../biz/User';
import { ILoginResponse, IloginResponsePermissions } from './structure-http-interface/ILogin/ILoginResponse';
import { NbMenuItem } from '@nebular/theme';

/**
 * 
 */
enum NAME_MENU_ITEM{
  PROY = "PROYECTOS",
  CRON = "PLAN DE TRABAJO",
  REC = "RECURSOS",
  FER = "FERIADOS",
  USU = "USUARIOS",
  ADM = "ADMINISTRACION DE HORAS",
  CLI = "CLIENTES",
  ACT = "ACTIVIDADES",
  ITE = "ITERACIONES",
  FLU = "FLUJO DE TRABAJO ISSUES",
  ROL = "ROLES",
  ISS = "ISSUES",
  GPY = "GESTION DE PROYECTOS",
  INF = "INFORMES",
  CAM = "CAMBIO CONTRASEÑA",
  PAG = "PAGOS"
}

export enum ROLES_KEYS{
  MENU = "menu",
}

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  public menu:Menu;
  public administrador:boolean=false;

  /**
   * 
   * @param httpService 
   * @param dummyService 
   */
  constructor( 
    private httpService:HttpService,
    private dummyService:DummyService) { 
      this.menu = null;
  }
  /**
   * 
   */
  async loadMenu(user:User):Promise<void>{
    let menu:IMenuResponse =  await this.httpService.doPostHttp<IMenuResponse>("/getmenu", this.httpService.getRequestMenu())
    localStorage.setItem("menu",JSON.stringify(menu));
    this.buildMenu(menu,user);
  }
  /**
   * 
   * @param menu 
   * @param user 
   */
  public buildMenu(menu:IMenuResponse, user:User){
    this.menu = new Menu(menu);
    this.menu.interface = this.getMenuByPermission(user);
  }


  /**
   * 
   * @param user 
   * @returns 
   */
  getMenuByPermission(user:User):NbMenuItem[]{
    let permissions = (user.decorator as ILoginResponse).permisos;
    let menuByPermission : IMenuResponseItems[] =  this.menu.items.filter((item:IMenuResponseItems)=>{
        return permissions.some((i:IloginResponsePermissions)=>i.id_menu === item.id)
    });
    let menu : NbMenuItem[] = [];

    let optionDashboard: NbMenuItem = {
      icon:"home",
      title:"Inicio",
      link:"/pages/site/dashboard"
    };

    menu.push(optionDashboard);

    for(let item of menuByPermission){
      let option: NbMenuItem = {
        title:"",
        children:[]
      };
      option.title = item.menu_descri;
      for(let permision of permissions){
        let create:boolean = (permision.id_menu === item.id) && (permision.crear === 1);
        let edit:boolean = (permision.id_menu === item.id) && (permision.editar === 1);
        let disable:boolean = (permision.id_menu === item.id) && (permision.inhabilitar === 1);
        let read:boolean = (permision.id_menu === item.id) && (permision.consultar === 1);
        let menuLinkView = "";
        let menuLinkCreate = "";
        if(permision.id_menu == 7 && (permision.consultar != 1  || permision.inhabilitar != 1)){
          this.administrador = true;
        }

        switch(option.title.toUpperCase()){
          case(NAME_MENU_ITEM.PROY):
            option.icon = "star-outline";
            menuLinkCreate = "/pages/site/create-proyect";
            menuLinkView = "/pages/site/view-proyect";
          break;
          case(NAME_MENU_ITEM.USU):
           option.icon = "person-outline";
            menuLinkCreate = "/pages/site/create-usuarios";
            menuLinkView = "/pages/site/view-usuarios";
          break;
          case(NAME_MENU_ITEM.ADM):
           option.icon = "clock-outline";
            menuLinkCreate = "/pages/site/create-adm-horas";
            menuLinkView = "/pages/site/view-adm-horas";
          break;  
          case(NAME_MENU_ITEM.CLI):
           option.icon = "people-outline";
            menuLinkCreate = "/pages/site/create-clientes";
            menuLinkView = "/pages/site/view-clientes";
          break;       
          case(NAME_MENU_ITEM.ACT):
            menuLinkCreate = "/pages/site/create-actividad";
            menuLinkView = "/pages/site/view-actividad";
          break;  
          case(NAME_MENU_ITEM.REC):
            option.icon = "refresh-outline";
            menuLinkCreate = "/pages/site/crear-recursos";
          break;  
          case(NAME_MENU_ITEM.ITE):
           option.icon = "flip-outline";
            menuLinkCreate = "/pages/site/create-iteracion";
            menuLinkView = "/pages/site/view-iteraciones";
          break;   
          case(NAME_MENU_ITEM.FLU):
            option.icon = "repeat-outline";
            menuLinkCreate = "/pages/site/create-flujo";
            menuLinkView = "/pages/site/view-flujos";
          break;            
          case(NAME_MENU_ITEM.ROL):
            option.icon = "unlock-outline";
            menuLinkCreate = "/pages/site/create-rol";
            menuLinkView = "/pages/site/view-roles";
          break; 
          case(NAME_MENU_ITEM.CRON):
           option.icon = "briefcase-outline";
            menuLinkCreate = "/pages/site/crear-cronograma";
            menuLinkView = "/pages/site/view-cronograma";
          break; 
          case(NAME_MENU_ITEM.GPY):
          option.icon = "star-outline";
            menuLinkCreate = "/pages/site/gestion-proyectos";
          break; 
          case(NAME_MENU_ITEM.FER):
           option.icon = "calendar-outline";
            menuLinkCreate = "/pages/site/crear-feriados";
            menuLinkView = "/pages/site/view-feriados";
          break; 
          case(NAME_MENU_ITEM.INF):
            option.icon = "book-outline";
            menuLinkView = "/pages/site/view-informes";
            menuLinkCreate = "";
          break; 
          case(NAME_MENU_ITEM.CAM):
          option.icon = "shield-outline";
          menuLinkView = "";
          menuLinkCreate = "/pages/site/cambio-contrasena";
        break; 
          case(NAME_MENU_ITEM.ISS):
          option.icon = "repeat-outline";
          menuLinkCreate = "/pages/site/create-issues";
          menuLinkView = "/pages/site/view-issues";
        break; 
        case(NAME_MENU_ITEM.PAG):
        option.icon = "credit-card-outline";
        menuLinkCreate = "";
        menuLinkView = "/pages/site/view-pagos";
      break; 
          default:
            
          break;
        }

        if(read){
          option.children.push({
            icon:"eye-outline",
            title:"Ver / Administrar",
            link:menuLinkView
          });
        }
        if(create){
          option.children.push({
            icon:"edit-outline",
            title:"Crear",
            link:menuLinkCreate
          });
        }
        if(option.title.toUpperCase() === NAME_MENU_ITEM.PROY && read){
          option.children.push({
            icon:"activity-outline",
            title:"SLA",
            link:"/pages/site/sla"
          });
        }
      }
      menu.push(option);
    }
  
    let optionLogout: NbMenuItem = {
      icon:"log-out-outline",
      title:"Cerrar sesión",
      link:"/pages/site/logout"
    };
    menu.push(optionLogout);
   return menu;
  }
}